<template>
  <main class="content">
    <Hero :title="data?.title"/>
    <article class="maxw--waist block dynamic-zone">
      <template v-for="zone in data?.content" :key="zone.id">
        <div class="rendered" v-if="zone.__component === 'content.text'" v-html="$md.render(zone.content || '')"></div>
        <div v-else-if="zone.__component === 'content.image'" class="image_holder">
          <StrapiImageHazy 
            v-for="image in flattenCollection(zone.images)"
            :key="image.id"
            loading="lazy" 
            :placeholder="image.placeholder"
            :src="getFlattenedStrapiImageLocation(image)" 
            provider="strapi"
          />
        </div>
        <div v-else-if="zone.__component === 'content.button'" class="button_holder">
          <nuxt-link :to="zone.link" class="btn" :class="{ 'btn--secondary': zone.type === 'secondary' }">{{ zone.content }}</nuxt-link>
        </div>
      </template>
    </article>
  </main>
</template>

<script lang="ts" setup>
import type DynamicPage from "~/typings/strapi/pages/dynamicPage";

const route = useRoute();
const slug = (route.params.slug as string[]).join('/');

const { data } = await useStrapiPage<DynamicPage>(slug, 'fallback');

useHead({
  title: data.value?.title
})

definePageMeta({
  pageTransition: pageTransitionConfig,
});
</script>

<style lang="scss">
.image_holder {
  width: 100%;
  display: block;

  img {
    max-width: 100%;
  }
}

.dynamic-zone {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 2rem;
}
</style>
